<template>
    <div>
        <input-label v-if="label" :for_element="name"> {{ $t(label) }}</input-label>

        <ul class="flex flex-1"
            :class="[
                vertical ? 'flex-col' : 'flex-col sm:flex-row',
                { 'flex flex-wrap flex-1 justify-evenly sm:justify-center': wrap },
                group_class
            ]"
        >
            <li v-for="option in options" :class="item_class">
                <input-radio-button
                    class="py-2 sm:py-1"
                    :value="option.value"
                    :label="option.label"
                    :selected="selected == option.value"
                    @selected="select(option.value)"
                    :read_only="read_only"
                    :size="size"
                />
            </li>

            <input type="hidden" :name="name" :value="selected" />
        </ul>
    </div>
</template>

<script>
import InputRadioButton from './input-radio-button.vue';

export default {
    components: {
        InputRadioButton,
    },

    props: {
        label: {},
        name: {},
        value: {},
        options: {
            type: Array,
            default: () => [],
        },
        group_class: {},
        vertical: { default: false },
        nullable: { default: false },
        wrap: { default: false },
        read_only: { default: false },
        size: { default: 'normal' },
        item_class: {},
    },

    data() {
        return {
            selected: this.value,
        }
    },

    methods: {
        select(value) {
            if (this.selected == value && this.nullable) {
                this.selected = null;
            } else {
                this.selected = value;
            }

            this.$emit('input', this.selected);
        },
    },
}
</script>
